var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jumbo-modal',{attrs:{"modalId":_vm.modalId,"title":"Preview Viewer"},on:{"hide":_vm.closePreviewViewerModal},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.documentType === _vm.documentTypes.TEXT)?_c('text-viewer'):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }